import { Types } from '@store/types';

const initialState = [];

const TechPackReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.FETCH_TECHPACK:
			return [...initialState, ...action.payload];
		default:
			return state;
	}
};

export default TechPackReducer;
